import styled from 'styled-components';

import { Dialog } from '#src/components/dialog/index.tsx';
import { Placeholder as WalletPlaceholder } from '#src/contexts/wallet/Placeholder/index.tsx';
import { useScreenSize } from '#src/hooks/device/useScreenSize.ts';
import { useIsMobileApp } from '#src/hooks/useIsMobileApp.ts';

const WalletFrame = styled.div`
  display: flex;
  min-height: 250px;
  padding: var(--triple-unit);
  & > :first-child {
    display: flex;
    width: 100%;
    min-height: 100%;
  }
`;

type Props = {
  open: boolean;
  onBack: () => void;
};
export const PasswordForgottenDialog = ({ open, onBack }: Props) => {
  const { up: isTablet } = useScreenSize('tablet');
  const { isMobileApp } = useIsMobileApp();

  return (
    <Dialog
      open={open}
      onBack={onBack}
      maxWidth="sm"
      fullWidth
      hideHeader
      fullScreen={isTablet || isMobileApp}
    >
      <WalletFrame>
        <WalletPlaceholder />
      </WalletFrame>
    </Dialog>
  );
};
